module.exports = __webpack_public_path__ + "static/img/garden-wall.2707285.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/garden-wall.jpg
// module id = CNsI
// module chunks = 0